var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconBookConfirm = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 35,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.672 15.699c-.28.004-.548.115-.748.312l-4.026 3.92-4.027 3.919-1.548-3.634a1.09 1.09 0 0 0-1.438-.592 1.084 1.084 0 0 0-.56 1.45l2.173 5.085a1.086 1.086 0 0 0 1.758.355l9.186-8.944c.322-.31.422-.786.253-1.199a1.089 1.089 0 0 0-1.023-.672Z",
  fill: "#B18D3B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.683 0a1.087 1.087 0 0 0-1.068 1.1v1.33h-5.03a1.316 1.316 0 0 0-.103 0c-.557.056-.98.524-.98 1.083v6.442c-.003.05-.003.1 0 .151v23.597c-.001.6.482 1.09 1.083 1.091h26.837c.6-.001 1.085-.49 1.083-1.09V10.124c.004-.06.004-.12 0-.178V3.513a1.087 1.087 0 0 0-1.083-1.082h-5.03V1.099a1.089 1.089 0 1 0-2.174 0v1.332H8.789V1.099A1.083 1.083 0 0 0 7.683 0ZM2.676 4.604h3.94V5.93a1.089 1.089 0 0 0 1.864.784c.204-.21.316-.492.31-.784V4.604h12.427V5.93a1.086 1.086 0 1 0 2.174 0V4.604h3.94v4.34H2.675v-4.34Zm0 6.514H27.33V32.62H2.676V11.118Z",
  fill: "#999"
})));

export default SvgIconBookConfirm;